// base
import React from 'react';

// styles
import { StyledSplashLoader } from './style';

// jsons
import loadingAnimations from './circle-loading.json';
import loadingAnimationGs from './circle-loading-gs.json';

// hooks
import { usePkgCheck } from 'hooks';

// constants
import { PKG_2 } from 'constants/const';

// libraries
import Lottie, { type LottieProps } from 'react-lottie';

interface SplashLoaderProps extends Omit<LottieProps, 'options'> {
  bgColor?: string;
  onSegmentStart?: () => void;
  onCompleted?: () => void;
}

export const SplashLoader: React.FC<SplashLoaderProps> = ({
  bgColor = '#ffffff7a',
  onSegmentStart,
  onCompleted,
  ...props
}) => {
  const { pkgNo } = usePkgCheck();

  const handleSegmentStart = () => {
    onSegmentStart?.();
  };

  const handleComplete = () => {
    onCompleted?.();
  };

  return (
    <StyledSplashLoader $bgColor={bgColor}>
      <Lottie
        style={{ transform: 'scale(0.16)' }}
        isClickToPauseDisabled
        eventListeners={[
          {
            eventName: 'segmentStart',
            callback: handleSegmentStart
          },
          {
            eventName: 'complete',
            callback: handleComplete
          }
        ]}
        {...props}
        options={{
          loop: true,
          autoplay: true,
          animationData: pkgNo === PKG_2 ? loadingAnimationGs : loadingAnimations,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
          }
        }}
      />
    </StyledSplashLoader>
  );
};
